import { Button, cn, PageTabsContent } from "@tellescope/ui";
import { Check, Lock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { EditUserForm } from "./useEditUserForm";

export interface AccessTabContentProps {
  form: EditUserForm;
}

const HAS_ACCESS = -1;
const LOCKED = 0;

export const AccessTabContent = ({ form }: AccessTabContentProps) => {
  const { t } = useTranslation("settings");
  const lockedOutUntil = form.values.lockedOutUntil;
  const hasAccess = lockedOutUntil === HAS_ACCESS;

  const accessOptions = [
    { value: HAS_ACCESS, title: t("Has Access"), description: t("User can login and access the platform") },
    { value: LOCKED, title: t("Locked"), description: t("User will not be able to log in when locked") },
  ];

  return (
    <PageTabsContent
      value="access"
      className="px-6 py-4 space-y-6 overflow-y-auto"
      style={{
        maxHeight: "min(80vh, 900px)",
      }}
    >
      <div className="flex flex-col items-center gap-4 pt-4">
        {hasAccess ? (
          <Check className="h-20 w-20 rounded-full bg-gray-100 p-5 text-gray-500 overflow-visible" />
        ) : (
          <Lock className="h-20 w-20 rounded-full bg-gray-100 p-5 text-gray-500 overflow-visible" />
        )}
        <span className="font-semibold text-lg">{t("User Access Status")}</span>
      </div>
      <div className="flex flex-col gap-2">
        {accessOptions.map((option) => (
          <Button
            key={option.value}
            type="button"
            variant="outline"
            onClick={() => form.setFieldValue("lockedOutUntil", option.value)}
            className={cn(
              "h-auto flex-col items-start gap-0 py-3 px-4 text-left whitespace-normal",
              lockedOutUntil === option.value && "border-primary bg-gray-100 ring-1 ring-primary"
            )}
          >
            <span className="font-medium text-lg">{option.title}</span>
            <span className="text-sm font-normal text-muted-foreground">{option.description}</span>
          </Button>
        ))}
      </div>
    </PageTabsContent>
  );
};
